<template>
  <router-view />
</template>

<script setup lang="ts">
definePage({
  meta: {
    title: "User Management",
    icon: "user-multiple",
    scope: "User.Read.TeamManager",
  },
  redirect: "/users/list",
});
</script>
